import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from 'class-variance-authority';
import { memo } from 'react';
/**
 * IconPathRenderer — internal SVG path renderer for IconPrimitive.
 *
 * This is an internal implementation detail of the aether icon system.
 * Use `IconPrimitive` with `type="path"` instead of importing this directly.
 *
 */
export const IconPathRenderer = memo(function IconPathRenderer({ paths, size = 20, className, title, description, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, style, viewBox = '0 0 24 24', strokeWidth = 1.75, strokeLinecap = 'round', strokeLinejoin = 'round', }) {
    if (paths == null) {
        return null;
    }
    const resolvedSize = size === 'inherit' ? '1em' : size;
    const pathList = Array.isArray(paths) ? paths : [paths];
    return (_jsxs("svg", { role: "img", xmlns: "http://www.w3.org/2000/svg", width: resolvedSize, height: resolvedSize, viewBox: viewBox, fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: strokeLinecap, strokeLinejoin: strokeLinejoin, className: cx('inline-flex shrink-0', className), style: style, "aria-label": ariaLabel, "aria-hidden": ariaHidden, children: [title && _jsx("title", { children: title }), description && _jsx("desc", { children: description }), pathList.map((d, i) => (_jsx("path", { d: d }, i)))] }));
});
//# sourceMappingURL=IconPathRenderer.js.map